module.exports = __webpack_public_path__ + "static/bg-3af77c1b125e5e9e359ad8c1406e77f9.svg";